import
moment from 'moment';
export let handleDateInputChange = (e) => {
    // if (!e ? .target) return; // Exit if event or target is undefined
    if (!e || !e.target) return; // Exit if event or target is undefined
    const rawData = e.target.value || "";
    const data = rawData.replace(/[^\d/]/g, ""); // allow digits and slashes only
    const digit = data.replace(/\D/g, "").slice(0, 8);

    let autoFormat = "";
    for (let i = 0; i < digit.length; i++) { // auto slashing
        if (i === 2 || i === 4) autoFormat += "/";
        autoFormat += digit[i];
    }
    const isValidFormat = /^(\d{0,2}(\/\d{0,2}(\/\d{0,4})?)?)?$/.test(data); // formating the input
    const formattedValue = isValidFormat ? data : autoFormat;
    e.target.value = formattedValue.slice(0, 10);
    if (formattedValue.length === 10) {
        const m = moment(formattedValue, "MM/DD/YYYY", true);
        if (m.isValid()) { // final validation
        }
    }
};